import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const generateImgixUrl = (url) => {
  const res = url.replace('https://front.travpromobile.com/', 'https://imgtravpromobile.imgix.net/');
  const returnValue = res + '?fit=clip&w=200&h=auto';
  return returnValue;
};

const ContactViewCard = ({ name, title, telephone, town, mail, imageUrl, other }) => {
  return (
    <div className="contactView">
      <div className="contactView__Content">
        {imageUrl && <img className="headshot" src={generateImgixUrl(imageUrl)} alt={`${name} - ${name}`} />}
        <h1>{name}</h1>
        <h2>{title}</h2>
        {town !== '////' && <p>{town && <strong>{town}</strong>}</p>}
        {telephone && <a href={`tel:${telephone.trim()}`}>
          <FontAwesomeIcon icon={['fas', 'phone']} />+{telephone}
        </a>}
        {mail.emails[0].email !== 'test@travpromobile.com' && <a href={`mailto:${mail.emails[0].email}`}>
          <FontAwesomeIcon icon={['fas', 'envelope']} />
          {mail.emails[0].email}
        </a>}
        {other && <div className="quote">{other.split('\n').map(e => <p>{e}</p>)}</div>}
      </div>
    </div>
  );
};

export default ContactViewCard;
